export enum DropdownMenuStatus {
  CLOSED = 'CLOSED',
  IS_TRANSITIONING = 'IS_TRANSITIONING',
  OPEN = 'OPEN',
}
